import { Component, OnInit, ChangeDetectorRef, OnDestroy, ChangeDetectionStrategy, ViewChild } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { ShareDataService } from "../../services/shareDataServic";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { Subscription } from "rxjs";
import { RegistrationDataService } from "./registerationData.service";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { InputValidationMaxLength, SnackBarMessageType, InputDataType } from "../../shared/contentTypes";
import { Router } from "@angular/router";
import { SettingsService } from "../../services/settings.service";
import { SettingsRegistrationDataViewModel } from "../../shared/models/settings.model";
import { RegistrationDataViewModel } from "../../shared/models/registration.model";
import { LocationService } from "../location/location.service";
import { CustomerInputFieldViewModel, LocationViewModel } from "../../shared/models";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { UserHelperService } from "../../services/userHelper.service";
import { BottomSheetHelperService } from "../../services/bottomSheetHelper.service";
import { RegistrationLocationDialogComponent } from "../../modalDialogs/registrationLocationDialog/registrationLocationDialog.component";
import { OverlaySpinnerService } from "../overlayspinner/overlaySpiner.service";
import { IOSHelperService } from "../../services/IOSHelper.service";
import { FormHelperService } from "../../services/formHelper.service";
import { FormGroup } from "@angular/forms";
import { ValidationErrorType } from "../../shared/validator/validatorMessage.interface";
import { DynamicFormFieldsComponent } from "../../directives";

@Component({
  selector: "registerationData",
  templateUrl: "./registerationData.component.html",
  styleUrls: ["./registerationData.component.scss"],
  providers: [OverlaySpinnerService, FormHelperService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegisterationDataComponent implements OnInit, OnDestroy {
  @ViewChild("dynamicFormFieldsComponent") dynamicFormFieldsComponent: DynamicFormFieldsComponent;

  private langSubscriber: Subscription;

  public locations: LocationViewModel[];
  public registrationFields: CustomerInputFieldViewModel[] = [];

  public settingViewModel: SettingsRegistrationDataViewModel = new SettingsRegistrationDataViewModel();

  private returnUrl: string = "";

  public inputDataType = InputDataType;
  public type = ValidationErrorType;
  public inputMaxLength = InputValidationMaxLength;

  public isSubmitted: boolean = false;// to control location selection error message
  public likedLocationIds: number[] = [];
  public registerWelcomeText: string = "";
  public firstName: string = "";
  public isDateValid: boolean = true;

  constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _coreLogService: CoreLogService
    , private _router: Router
    , private _shareDataService: ShareDataService
    , private _locationService: LocationService
    , private _formHelperService: FormHelperService
    , private registrationDataService: RegistrationDataService
    , private _settingsService: SettingsService
    , private internationalisationService: InternationalisationService
    , private _userHelperService: UserHelperService
    , private _objObsInjectHelper: CircularInjectionHelper
    , private _snackBarService: SnackBarService
    , private _overlaySpinnerService: OverlaySpinnerService
    , private _iosHelperService: IOSHelperService
    , private _bottomSheetHelperService: BottomSheetHelperService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("RegistrationDataComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.loadAndCreateRegistrationFields();
    me.returnUrl = me._shareDataService.getSharedDateByKey("returnUrl");

    me.langSubscriber = me.internationalisationService.localeChanged.subscribe(() => {
      me.PushChanges();
    });
    me.getSettingRegistrationData();
    me._shareDataService.resetSharedData();
    me.PushChanges();
  }


  public loadAndCreateRegistrationFields() {
    const me = this;
    me.registrationDataService.loadAndCreateRegistrationFields().then(fields => {
      me.registrationFields = fields;
      me.PushChanges();
    });
  }

  public onFormStatusChange(): void {
    this.PushChanges();
  }

  public get registrationForm(): FormGroup | null {
    const form = this.dynamicFormFieldsComponent && this.dynamicFormFieldsComponent.formGroup ?
      this.dynamicFormFieldsComponent.formGroup : null;
    return form;
  }

  private getSettingRegistrationData() {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    me._settingsService.GetSettingRegistrationDataViewModel()
      .then((settingViewModel) => {
        me.settingViewModel = settingViewModel;
        me._locationService.GetLocationViewModel()
          .then((locations) => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me.locations = locations;
            if (me.locations.length > 1) {
              me.locations.forEach(location => {
                if (location.like) {
                  me.likedLocationIds.push(location.hyp_cus_nr);
                }
              });
            } else {
              me.likedLocationIds.push(me.locations[0].hyp_cus_nr);
            }
            me.PushChanges();
          })
          .catch(() => {
            me._overlaySpinnerService.HideLayoutSpinner();
            me._snackBarService.ShowErrorMessageFailed(75);
          });
      })
      .catch(() => {
        me._overlaySpinnerService.HideLayoutSpinner();
        me._snackBarService.ShowErrorMessageFailed(76);
      });
  }

  /**
  * open Location filter dialog to select location user likes
  */
  public openLocationModal(): void {
    const me = this;
    const bootomSheetRef = me._bottomSheetHelperService.open(RegistrationLocationDialogComponent, {
      data: { locationIds: me.likedLocationIds, registered: false, locationData: me.locations }
    });
    bootomSheetRef.afterDismissed().subscribe((result: any) => {
      if (result && result !== "") {
        if (result.length > 0) {
          me.likedLocationIds = [];
          me.likedLocationIds.push(...result);
          me.PushChanges();
        } else {
          me.likedLocationIds = [];
          me.PushChanges();
        }
      }
    });
  }

  /**
   * Converts form data to typed RegistrationDataViewModel
   */
  private toRegistrationViewModel(): RegistrationDataViewModel {
    const formData = this.dynamicFormFieldsComponent.getDynamicFieldsInput();
    return Object.assign(new RegistrationDataViewModel(), formData);
  }

  /**
   * Saves user registration data and favorite locations
   */
  public async setUserInfo(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      const registrationData = me.toRegistrationViewModel();
      await me.registrationDataService.setUserInfo(registrationData, me.likedLocationIds);
      const isRegistered = await me._userHelperService.IsRegistrationConfirmed(true);
      me._overlaySpinnerService.HideLayoutSpinner();

      if (isRegistered) {
        me._snackBarService.ShowMessage(
          snackBarMessageKey.successfullyExecuted,
          SnackBarMessageType.Successful
        );
        me._router.navigate([me.returnUrl]);
      } else {
        me._snackBarService.ShowMessage(
          snackBarMessageKey.failed,
          SnackBarMessageType.Warning
        );
      }
    } catch (error) {
      me._overlaySpinnerService.HideLayoutSpinner();
      me._coreLogService.error('RegisterationDataComponent.setUserInfo', 'Error saving user info', error);
      me._snackBarService.ShowErrorMessageFailed(78);
    }
  }

  public handleEnterKey(event) {
    if (event.keyCode === 13) {
      // to avoid focus on input after closing the modal dialog
      const btnlocation: HTMLElement = document.getElementById("btnlocation");
      btnlocation.focus();
      btnlocation.click();
    }
  }

  /**show all validation message by clicking on desabled button */
  public showValidationMessage(formGroup: FormGroup): void {
    const me = this;
    me._formHelperService.showValidationMsg(formGroup);
    me.isSubmitted = true;
    me.PushChanges();
  }

  public navigateBack(): void {
    const me = this;
    me._objObsInjectHelper.yourAppServer.Auth.SignOut()
      .then((isSignOut) => {
        // Clear userData in yourAppServer.Auth and RegisterData in HelperService
      })
      .catch((e) => {
        me._snackBarService.ShowErrorMessageFailed(79);
      });
    me._router.navigateByUrl("/");
  }

  public setWebView() {
    const me = this;
    me._iosHelperService.setWebviewAfterBlur();
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me.langSubscriber) {
      me.langSubscriber.unsubscribe();
    }
  }
}
